var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInformation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "-0.5 -0.5 14 14",
    height: 14,
    width: 14,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "information-circle--information-frame-info-more-help-point-circle"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    stroke: "#4b5168",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M6.5 12.535714285714286c3.3334785714285715 0 6.035714285714286 -2.702235714285714 6.035714285714286 -6.035714285714286C12.535714285714286 3.1665678571428573 9.833478571428572 0.4642857142857143 6.5 0.4642857142857143 3.1665678571428573 0.4642857142857143 0.4642857142857143 3.1665678571428573 0.4642857142857143 6.5c0 3.3334785714285715 2.702282142857143 6.035714285714286 6.035714285714286 6.035714285714286Z",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    stroke: "#4b5168",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M5.107142857142858 9.285714285714286h2.7857142857142856",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    stroke: "#4b5168",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M6.5 9.285714285714286V6.035714285714286H5.571428571428571",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 2605"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 1111",
    stroke: "#4b5168",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M6.5 3.9464285714285716c-0.12820785714285715 0 -0.23214285714285715 -0.103935 -0.23214285714285715 -0.23214285714285715s0.103935 -0.23214285714285715 0.23214285714285715 -0.23214285714285715",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 1112",
    stroke: "#4b5168",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M6.5 3.9464285714285716c0.12820785714285715 0 0.23214285714285715 -0.103935 0.23214285714285715 -0.23214285714285715s-0.103935 -0.23214285714285715 -0.23214285714285715 -0.23214285714285715",
    strokeWidth: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInformation);
export default __webpack_public_path__ + "static/media/information.6d4abd9575bbc11aef93fd0798381c76.svg";
export { ForwardRef as ReactComponent };